import MDTypography from "@/components/atoms/MDTypography";
import { IMedia } from "@/interfaces/media.interface";

interface TextProps {
  media: IMedia;
}

const TextMedia: React.FC<TextProps> = ({ media }) => {
  return <MDTypography variant="body2">{atob(media.file)}</MDTypography>;
};

export default TextMedia;
